const ErrorFallback = ({ error, resetErrorBoundary }: any) => {
  return (
    <div role="alert">
      <h1>{error.status} Error</h1>
      <pre>{error.message}</pre>
      <p>{error.statusText}</p>
      <p>headers: {error.headers}</p>
      <p>config: {error.config}</p>
      <p>request: {error.request}</p>
      <p>response: {error.response}</p>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
};

export default ErrorFallback;
